import { MasteryTypeResponse } from './fetchMastery';

export const fetchMastered = async (path: string, token: string): Promise<MasteryTypeResponse> => {
  try {
    const response = await fetch(`${import.meta.env.VITE_BASE_URL}${path}`, {
      method: 'GET',
      headers: {
        Authorization: token,
      },
    });
    const data: MasteryTypeResponse = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw error;
  }
};
